import {Injectable} from '@angular/core';
import {Http} from '@angular/http';

import 'rxjs/add/operator/toPromise';

@Injectable()
export class ArticleReleaseService {

    private api_url_get_locations_not_empty_by_article = './api/server.php?cmd=GET_LOCATIONS_NOT_EMPTY_BY_ARTICLE';
    private api_url_set_location_release_session = './api/server.php?cmd=SET_LOCATION_RELEASE_SESSION';
    private api_url_add_locations_to_os_order_details_session = './api/server.php?cmd=ADD_LOCATIONS_TO_OS_ORDER_DETAILS_SESSION';
    private api_url_add_new_line_session = './api/server.php?cmd=ADD_NEW_LINE_SESSION';

    constructor(private http: Http) {

    }

    GetLocationsNotEmpty(id_article: any, quantity: any): Promise<Object> {
        return this.http.get(this.api_url_get_locations_not_empty_by_article
            + '&id_article=' + id_article
            + '&quantity=' + quantity
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    SetLocationRealeaseSession(id_article: any, location_release: any): Promise<Object> {
        return this.http.get(this.api_url_set_location_release_session
            + '&id_article=' + id_article
            + '&location_release=' + location_release
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    AddLocationsToOsOrderDetailsSession(): Promise<Object> {
        return this.http.get(this.api_url_add_locations_to_os_order_details_session
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    AddNewLineSession(recap_to_send: any): Promise<Object> {
        return this.http.get(this.api_url_add_new_line_session
            + "&index_sess=" + recap_to_send.index_sess
            + "&quantity=" + recap_to_send.quantity
            + "&quantity_to_release=" + recap_to_send.quantity_to_release
            + "&location=" + recap_to_send.location
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// ./src/app/article-release.service.ts